import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import _moment from 'moment';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import {CentreService} from "../../../services/centre.service";
import {Centre} from "../../../interfaces/Centres";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

interface Ranking {
  rankings: [ {
    Occupancy: number;
    centerName: string;
    centreCode: string;
    startDate: any; // Assuming Timestamp type
    endDate: any; // Assuming Timestamp type
    totalRooms: number;
    weekId: number;
    avg?:number;
  }];
}
export interface RankingData{
  Occupancy: number;
  centerName: string;
  centreCode: string;
  startDate: any; // Assuming Timestamp type
  endDate: any; // Assuming Timestamp type
  totalRooms: number;
  weekId: number;
  avg?:number;
}
@Component({
  selector: 'app-occupancy',
  templateUrl: './occupancy.component.html',
  styleUrls: ['./occupancy.component.scss'],
})
export class OccupancyComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  startDate: any;
  endDate: any;
  rankings: Ranking|undefined;
  averageOccupancy: number = 0;
  displayedColumns= ['dateString','centerName','Occupancy','totalRooms'];
mCentres:Centre[]=[]
  constructor(private firestore: AngularFirestore,
              private readonly mCentreService:CentreService) {}

  ngOnInit() {
    this.fetchData();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  fetchData() {
    this.mCentreService.getAllCentres().pipe(takeUntil(this._destroyed$)).subscribe(res=>{
      this.mCentres= res
      this.mCentres.forEach(centre=>{
        this.getCentreRankings(centre.centreCode,centre)
      })
    })
//     this.firestore.collection<Ranking>('centre-Rankings').valueChanges({idField:'id'}).subscribe(data => {
//      let i=0
// data.forEach(it=>{
//   i++
//   console.log(i,it)
//   // @ts-ignore
//   // @ts-ignore
//   this.rankings = Object.entries(it.rankings).map(([dateString, data]) => ({
//     //@ts-ignore
//     dateString, ...data, // Spread operator to include all data properties
//   }));
//   console.log(this.rankings)
// })
//     });
  }

  search(){
    this.fetchData()

  }

  private async getCentreRankings(centreCode: string, centre: Centre) {
    let rankingDoc=await this.firestore.doc<Ranking>(`centre-Rankings/${centreCode}`).get().toPromise()
    let ranking = rankingDoc?.data()
    console.log(ranking)
      // @ts-ignore
    const rankingsArray = Object.entries(ranking?.rankings).map(([dateString, data]) => ({
      //@ts-ignore
      dateString, ...data, // Spread operator to include all data properties
    }));
   // this.rankings!!.avg =this.calculateAvgEfficiency(this.rankings)
    console.log(rankingsArray.length)
this.calculateAvgEfficiency(rankingsArray)
}

  private calculateAvgEfficiency(rankings: RankingData[]) {
let totalOccupancy=';'
  this.rankings?.rankings.forEach(it=>{
    console.log(it)
  })

  }
}
